<template src="./template.html"></template>

<script>
export default {
    name: "DashboardLoader"
}
</script>